import React from "react";
import * as R from "ramda";
import { Query } from "react-apollo";

import { withApolloState } from "../../util";
import { formatDatetimeString } from "../../formatters/formatDateTimeString";
import { GET_LOBS_HISTORY } from "./queries";
import { Category, InfoTable } from "./InfoTable";

const lobsColumns = filename => title => [
    {
        id: "title",
        Header: title,
        accessor: "lineOfBusiness",
    },
    {
        id: "date",
        Header: "Date",
        accessor: "timestamp",
        Cell: row => formatDatetimeString({ str: row.value }),
    },
    {
        id: "source",
        Header: "Source",
        Cell: filename,
    },
];

const monitoringColumns = () => [
    {
        id: "oldMonLev",
        Header: "Old Monitoring Level",
        accessor: "oldMonitoringLevel",
    },
    {
        id: "oldFreq",
        Header: "Old Frequency",
        accessor: "oldFrequency",
    },
    {
        id: "newMonLev",
        Header: "New Monitoring Level",
        accessor: "newMonitoringLevel",
    },
    {
        id: "newFreq",
        Header: "New Frequency",
        accessor: "newFrequency",
    },
    {
        id: "date",
        Header: "Date",
        accessor: "timestamp",
        Cell: row => formatDatetimeString({ str: row.value }),
    },
];

const BulkUploadProcessHistoryInfoTable = ({ processRelayId, entityUlid }) => (
    <Query
        query={GET_LOBS_HISTORY}
        variables={{ entityUlid, id: processRelayId }}
        fetchPolicy="cache-and-network"
    >
        {withApolloState(({ data }) => {
            const filename = R.pathOr(
                "",
                ["process", "processHistory", "historyInput", "filename"],
                data
            );

            return (
                <div>
                    <InfoTable
                        title="LOBs Terminations"
                        data={data.lobTermination}
                        columns={lobsColumns(filename)}
                    />
                    <Category>Monitoring Level Changes</Category>
                    <InfoTable
                        title="Monitoring Changes"
                        data={data.monitoringChanges}
                        columns={monitoringColumns}
                        normalFirstTitle
                    />
                </div>
            );
        })}
    </Query>
);
export default BulkUploadProcessHistoryInfoTable;
